import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

// import moment from 'moment'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import styled from 'styled-components'
import { filterCaseInsensitive } from '../../../util'
import { Button, Form, Popconfirm, Input, Upload, Icon, Tooltip, Spin } from 'antd'

import * as stopCallSelectors from '../../../selectors/job/stopCall'
import { actions as stopCallActions } from '../../../redux/modules/jobFunctions/jobStopCallActions'

const { TextArea } = Input

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const propTypes = {
  selectedStopCall: PropTypes.object,

  loadingAttachments: PropTypes.bool,
  attachments: PropTypes.array,
  uploadingAttachment: PropTypes.bool,
  deletingAttachment: PropTypes.bool,

  fetchStopCallAttachments: PropTypes.func.isRequired,
  updateAttachmentDescription: PropTypes.func.isRequired,
  deleteStopCallAttachment: PropTypes.func.isRequired,
  uploadStopCallAttachment: PropTypes.func.isRequired
}

class AddEditModal extends Component {
  state = {
    fileList: [],
    attachmentDetailsVisible: false,
    attachmentName: null,
    attachmentDescription: '',
    attachmentId: null
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleEditAttachment = () => {
    const { selectedStopCall, updateAttachmentDescription } = this.props
    const { attachmentId, attachmentDescription } = this.state
    updateAttachmentDescription(attachmentId, selectedStopCall.id, attachmentDescription)
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  handleAttachmentDelete = event => {
    const { deleteStopCallAttachment, selectedStopCall } = this.props
    const { attachmentId } = this.state
    deleteStopCallAttachment({
      attachmentId: attachmentId,
      stopCallId: selectedStopCall.id
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  handleUploadAttachment = uploadParam => {
    const { uploadStopCallAttachment, selectedStopCall } = this.props

    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'stopCall')
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)

    uploadStopCallAttachment(formData, selectedStopCall.id)
  }

  render() {
    const {
      selectedStopCall,
      attachments,
      loadingAttachments,
      deletingAttachment,
      uploadingAttachment
    } = this.props

    const { fileList, attachmentDetailsVisible, attachmentName, attachmentDescription } = this.state

    const uploadPropsOnEdit = {
      multiple: true,
      fileList: fileList
    }

    return (
      <div>
        {selectedStopCall && (
          <FilesUploadContainer>
            <div className="row">
              <div className="col-md-6">
                <h5>
                  <Icon type="check" /> StopCall Files
                </h5>
              </div>
              <div className="col-md-6 text-right">
                {uploadingAttachment && (
                  <div className="text-success">
                    <Icon type="loading" /> Uploading File(s)
                  </div>
                )}
                {deletingAttachment && (
                  <div className="text-danger">
                    <Icon type="loading" /> Deleting File(s)
                  </div>
                )}
              </div>
            </div>
            {attachments && (
              <Spin spinning={loadingAttachments}>
                <ReactTable
                  defaultPageSize={5}
                  defaultFilterMethod={filterCaseInsensitive}
                  data={attachments}
                  getTrProps={(state, rowInfo, column, instance) => ({
                    onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                  })}
                  columns={[
                    {
                      Header: 'Attached Files',
                      columns: [
                        {
                          Header: 'Filename',
                          id: 'filename',
                          accessor: 'filename',
                          Cell: d => (
                            <Tooltip title={d.original.filename}>{d.original.filename}</Tooltip>
                          )
                        },
                        {
                          Header: 'Description',
                          id: 'description',
                          accessor: d => <Tooltip title={d.description}>{d.description}</Tooltip>
                        },
                        {
                          Header: 'Created By',
                          id: 'created_by',
                          accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                          Cell: d => {
                            const r = `${d.original.created_by_first_name} ${
                              d.original.created_by_last_name
                            }`
                            return <Tooltip title={r}>{r}</Tooltip>
                          },
                          minWidth: 70
                        },
                        {
                          Header: 'Updated By',
                          id: 'updated_by',
                          accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                          Cell: d => {
                            const r = `${d.original.updated_by_first_name} ${
                              d.original.updated_by_last_name
                            }`
                            return <Tooltip title={r}>{r}</Tooltip>
                          },
                          minWidth: 70
                        },
                        {
                          Cell: row => (
                            <Tooltip placement="left" title="Open this file on a new window">
                              <a target="_blank" href={row.original.signedUrl}>
                                <Icon type="export" className="fontSize20" />
                              </a>
                            </Tooltip>
                          ),
                          maxWidth: 35
                        }
                      ]
                    }
                  ]}
                  defaultSorted={[
                    {
                      id: 'id',
                      desc: true
                    }
                  ]}
                  className="-striped -highlight"
                />
              </Spin>
            )}
            {attachmentDetailsVisible && (
              <EditAttachmentContainer>
                <EditAttachmentTitle>
                  <Icon type="edit" /> Edit Attachment Area
                </EditAttachmentTitle>
                <div>
                  <EditingFileContainer>
                    <Icon type="file" /> {attachmentName}
                  </EditingFileContainer>
                </div>
                <div className="row">
                  <div className="col-md-10">
                    <TextArea
                      placeholder="Describe the attachment..."
                      rows={4}
                      onChange={this.onDescriptionChange}
                      value={attachmentDescription}
                    />
                  </div>
                </div>
                <div className="d-flex flex-row mt-2">
                  <Button onClick={this.handleEditAttachment}>
                    <Icon type="save" /> OK
                  </Button>{' '}
                  <Popconfirm
                    title="Are you sure you want to delete this attachment?"
                    onConfirm={this.handleAttachmentDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="danger" icon="delete" className="ml-2">
                      {' '}
                      DELETE
                    </Button>
                  </Popconfirm>
                </div>
              </EditAttachmentContainer>
            )}
            <br />
            <div>Upload Testing File(s)</div>
            <br />
            <Upload {...uploadPropsOnEdit} name="file" customRequest={this.handleUploadAttachment}>
              <Button>
                <Icon type="upload" /> Upload
              </Button>
            </Upload>
          </FilesUploadContainer>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  attachments: stopCallSelectors.getStopCallAttachments(state, props),
  loadingAttachments: stopCallSelectors.getAttachmentsLoading(state, props),
  uploadingAttachment: stopCallSelectors.getAttachmentUploading(state, props),
  deletingAttachment: stopCallSelectors.getAttachmentDeleting(state, props)
})
const mapDispatchToProps = (dispatch, props) => ({
  fetchStopCallAttachments: stopCallId =>
    dispatch(stopCallActions.fetchStopCallAttachments(stopCallId)),
  updateAttachmentDescription: (attachmentId, stopCallId, description) =>
    dispatch(
      stopCallActions.updateStopCallAttachmentDescription(attachmentId, stopCallId, description)
    ),
  deleteStopCallAttachment: params => dispatch(stopCallActions.deleteStopCallAttachment(params)),
  uploadStopCallAttachment: (formData, stopCallId) =>
    dispatch(stopCallActions.uploadStopCallAttachment(formData, stopCallId))
})

AddEditModal.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddEditModal)))



// WEBPACK FOOTER //
// ./src/components/jobs/stop_call/Attachments.js